import { render, staticRenderFns } from "./HistoriaSop.vue?vue&type=template&id=6963b033"
import script from "./HistoriaSop.vue?vue&type=script&lang=js"
export * from "./HistoriaSop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports